import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "LeaveReview",
  components: {},
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    // "$store.state.queuedCloudTTSSentences": "processCloudTTSPayloads",
  },
  props: {},
  data: function data() {
    return {
      submittedFeedbackAlready: false,
      hasSubmittedRating: false,
      rating: 0,
      showReviewButton: false,
      feedback: "",
      dualSubmission: false,
      handleLowerScores: false,
      shareFeedbackText: "Share Feedback With Us",
      lowerScoreSentence: "",
      success: false
      // data
    };
  },
  methods: {
    handleClose: function handleClose() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // no rating so just close
              if (_this.rating === 0) {
                _this.$store.commit('updateLeaveReview', false);
              }
              // has rating but no submission to feedback
              if (!(_this.rating > 0 && !_this.submittedFeedbackAlready)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 4;
              return _this.submitFeedback();
            case 4:
              _this.$store.commit('updateLeaveReview', false);

              // has rating but submission already done
              _context2.next = 8;
              break;
            case 7:
              _this.$store.commit('updateLeaveReview', false);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    submitRating: function submitRating() {
      this.hasSubmittedRating = true;
      this.handleRating();
    },
    // opens browser to app store
    leaveReviewOnAppStore: function leaveReviewOnAppStore() {
      if (this.isRunningInTWA()) {
        var appPackageName = "com.aivitar.aivitarapp";
        var reviewUrl = "https://play.google.com/store/apps/details?id=".concat(appPackageName, "&showAllReviews=true");
        window.open(reviewUrl, "_system");
      }
    },
    isRunningInTWA: function isRunningInTWA() {
      return window.matchMedia("(display-mode: fullscreen)").matches;
    },
    submitFeedback: function submitFeedback() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this2.sendFeedbackToServer();
            case 3:
              _this2.success = true;
              _context3.next = 9;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              console.log(_context3.t0);
            case 9:
              //if we are doing both send them to the app store too
              if (_this2.dualSubmission) {
                _this2.leaveReviewOnAppStore();
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 6]]);
      }))();
    },
    sendFeedbackToServer: function sendFeedbackToServer() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
                  var localThis, axios, qs, token, dataConfig, data, config, response;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        //submit feedback to our database
                        localThis = _this3;
                        _context4.prev = 1;
                        axios = require("axios");
                        qs = require("qs");
                        token = localStorage.getItem("security");
                        dataConfig = {
                          token: token,
                          feedback: _this3.feedback,
                          rating: _this3.rating
                        };
                        data = qs.stringify(dataConfig);
                        config = {
                          method: "post",
                          url: "".concat(_this3.$store.state.systemRoute, "/leavefeedback"),
                          headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                          },
                          data: data
                        };
                        _context4.prev = 8;
                        _context4.next = 11;
                        return axios(config);
                      case 11:
                        response = _context4.sent;
                        console.log(JSON.stringify(response.data));
                        localThis.submittedFeedbackAlready = true;
                        _context4.next = 19;
                        break;
                      case 16:
                        _context4.prev = 16;
                        _context4.t0 = _context4["catch"](8);
                        reject(_context4.t0);
                      case 19:
                        resolve();
                        _context4.next = 25;
                        break;
                      case 22:
                        _context4.prev = 22;
                        _context4.t1 = _context4["catch"](1);
                        reject(_context4.t1);
                      case 25:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4, null, [[1, 22], [8, 16]]);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    closeModal: function closeModal() {
      this.$store.commit("updateLeaveReview", false);
    },
    changeStars: function changeStars(n) {
      if (!this.hasSubmittedRating) {
        this.rating = n;
      }
    },
    handleRating: function handleRating() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var n;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              n = _this4.rating;
              if (!(n === 5)) {
                _context6.next = 4;
                break;
              }
              _context6.next = 4;
              return _this4.sendFeedbackToServer();
            case 4:
              if (n > 4) {
                if (_this4.handleLowerScores) {
                  _this4.lowerScoreSentence = "Sweet! We love to hear that! Please leave a review on the app store!";
                  _this4.shareFeedbackText = "Share Feedback";
                  _this4.dualSubmission = true;
                  _this4.showReviewButton = false;
                } else {
                  _this4.showReviewButton = true;
                }
              } else {
                _this4.showReviewButton = false;
              }
              if (n <= 4) {
                _this4.handleLowerScores = true;
                if (n <= 2) {
                  _this4.lowerScoreSentence = "Bummer! What can we do to fix this?!";
                }
                if (n > 2 && n < 4) {
                  _this4.lowerScoreSentence = "Not a perfect score. We can do better! What should we work on?";
                }
                if (n === 4) {
                  _this4.lowerScoreSentence = "Dang! Almost five stars! What do we need to improve to get your five stars?";
                }
              }
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  }
});